/*
 * Public API Surface of common
 */
// export default {};

export { SvgIconsModule } from './svg-icons.module';
export * from './dialogs';
